import { render, staticRenderFns } from "./StatsStaffRegistrations.vue?vue&type=template&id=753f8c6f&"
import script from "./StatsStaffRegistrations.vue?vue&type=script&lang=js&"
export * from "./StatsStaffRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports